/*
 * @Author: Dom
 * @Date: 2022-05-27 09:13:32
 * @LastEditTime: 2022-08-17 15:22:57
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\account\service.ts
 */
import request from '@/utils/request'
import { TableListQueryParams, AccountInfoParamsType, DownloadType } from './data.d'

//账号编码获取账户信息
export async function getAccountByUserCode(params: AccountInfoParamsType): Promise<any>{
  return request({
    url: '/seller/v1/account/getAccountByUserCode',
    method: 'GET',
    params,
  })
}

//查询账户流水
export async function getAccountFlowListByPage(params?: TableListQueryParams): Promise<any> {
  return request({
    url: '/seller/v1/accountFlow/getAccountFlowListByPage',
    method: 'POST',
    data: params,
  })
}


//查询账期账单列表
export async function getAccountBillListByPage(params?: TableListQueryParams): Promise<any>{
  return request({
    url: '/seller/v1/accountBill/getAccountBillListByPage',
    method: 'POST',
    data: params,
  })
}

export async function accountBillDownload(params: DownloadType): Promise<any>{
  return request({
    url: '/seller/v1/accountBill/accountBillDownload',
    method: 'GET',
    params,
  })
}
